import { AxiosError, AxiosResponse, AxiosRequestConfig } from 'axios'
const IGNORE_RETRY_STATUSES = [422, 401]

export interface ResponseError {
  status: AxiosResponse['status']
  statusText: AxiosResponse['statusText']
  errorText: string
  headers: AxiosResponse['headers']
  data: AxiosResponse['data']
}

/**
 * Перехватчик отвалившегося запроса
 * @param {ResponseError} error
 */
export function ResponseInterceptorFail(error: AxiosError): Promise<ResponseError> {
  const { config = null, response = null } = error

  if (config === null || response === null) {
    // Необходимо для любых внутренних ошибок axios (к примеру Cancel)
    return Promise.reject(error)
  }

  const originalRequest = config

  if (IGNORE_RETRY_STATUSES.includes(response.status)) {
    // eslint-disable-next-line prettier/prettier
    (originalRequest as AxiosRequestConfig & { _retry: boolean })._retry = true
  }

  const rejectData: ResponseError = {
    status: response.status,
    statusText: response.statusText,
    errorText: error.toString(),
    headers: response.headers,
    ...(typeof response.data === 'object' ? response.data : { data: response.data }),
  }

  return Promise.reject(rejectData)
}
